import httpClient from '@/libs/http-client'

export function validateTimezone (values) {
  const url = `/timezone/validate_timezone`

  return httpClient.post(url, values).then(response => {
    return response.data.result
  })
}

export function updateTimezone (values) {
  const url = `/timezone/update_timezone`

  return httpClient.post(url, values).then(response => {
    return response.data.result
  })
}
